import { notification } from 'antd';

type NotificationType = 'success' | 'info' | 'warning' | 'error';

export const useNotification = () => {
  const [api, contextHolder] = notification.useNotification();

  const showNotification = (
    type: NotificationType,
    message: string,
    description?: string,
    duration?: number
  ) => {
    api[type]({
      message,
      description,
      duration: duration ?? 4.5, // Default 4.5 seconds
      placement: 'topRight',
    });
  };

  const success = (message: string, description?: string, duration?: number) =>
    showNotification('success', message, description, duration);

  const info = (message: string, description?: string, duration?: number) =>
    showNotification('info', message, description, duration);

  const warning = (message: string, description?: string, duration?: number) =>
    showNotification('warning', message, description, duration);

  const error = (message: string, description?: string, duration?: number) =>
    showNotification('error', message, description, duration);

  return {
    contextHolder,
    notification: {
      success,
      info,
      warning,
      error,
    },
  };
};